import angular from 'angular';
import { TokboxMicrophoneRenderer } from 'providers/video/tokbox/tokbox-microphone-renderer';
export default angular
    .module('doxy.realtime.common.services.selfMicrophoneRenderer', [])
    .factory('selfMicrophoneRenderer', ($rootScope) => new TokboxMicrophoneRenderer('self', $rootScope)).name;
